class BESSAppProjectProfilersUpdatedEvent extends BESSAppEvent {

    static name = "BESSAppProjectProfilersUpdatedEvent";

    constructor() {
        super(BESSAppProjectProfilersUpdatedEvent.name);

    }
}
